import { createAction } from "@reduxjs/toolkit";

const FETCHING_PROVINCE_LIST = 'FETCHING_PROVINCE_LIST';
const FETCHING_DISTRICT_LIST = 'FETCHING_DISTRICT_LIST';
const FETCHING_BANK_SUPPORT_LIST = 'FETCHING_BANK_SUPPORT_LIST';
const FETCH_MEETING_LIST = 'FETCH_MEETING_LIST';
const CREATE_MEETING = 'CREATE_MEETING';
export const UPDATE_MEETING = 'UPDATE_MEETING';
export const DELETE_MEETING = 'DELETE_MEETING';
export const FETCH_SCHOOLS = "FETCH_SCHOOLS";
export const FETCH_CLASSES = "FETCH_CLASSES";
export const FETCH_CLASSES_BY_SCHOOL = "FETCH_CLASSES_BY_SCHOOL";
export const FETCH_TEACHERS = "FETCH_TEACHERS";

export const fetchProviceList = createAction(FETCHING_PROVINCE_LIST);
export const fetchDistrictList = createAction(FETCHING_DISTRICT_LIST, (provinceId: string) => ({
  payload: { provinceId: provinceId }
}));

export const fetchBankSupportList = createAction(FETCHING_BANK_SUPPORT_LIST);
export const fetchMeetingsByTimeRange = createAction(FETCH_MEETING_LIST, (filters: any) => ({
  payload: { filters },
}))

export const createMeeting = createAction(CREATE_MEETING, (filters: any) => ({
  payload: { filters },
}))

export const updateMeeting = createAction(UPDATE_MEETING, (id: string, data: any) => ({
  payload: { id, data },
}))

export const deleteMeeting = createAction(DELETE_MEETING, (id: string,start_time, class_id? : any) => ({
  payload: { id,start_time, class_id },
}))

export const fetchSchools = createAction(FETCH_SCHOOLS);

export const fetchClasses = createAction(FETCH_CLASSES);

export const fetchClassesBySchool = createAction(FETCH_CLASSES_BY_SCHOOL, (schoolId: number) => ({
  payload: { schoolId },
}));

export const FETCH_SCHOOLS_PAGINATED = "FETCH_SCHOOLS_PAGINATED";
export const FETCH_CLASSES_BY_SCHOOL_PAGINATED = "FETCH_CLASSES_BY_SCHOOL_PAGINATED";

export const fetchSchoolsPaginated = createAction(
  FETCH_SCHOOLS_PAGINATED,
  (params: { page: number; page_size: number; search?: string }) => ({
    payload: params,
  })
);

export const fetchClassesBySchoolPaginated = createAction(
  FETCH_CLASSES_BY_SCHOOL_PAGINATED,
  (params: { schoolId: number; page: number; page_size: number; search?: string }) => ({
    payload: params,
  })
);

export const fetchTeachers = createAction(FETCH_TEACHERS, (schoolId: number, classId: number,type?:string|null, page?:number | null, pageSize?:number | null) => ({
  payload: { schoolId, classId,type, page, pageSize },
}));